<template>
    <responisble-persons-chooser
        v-if="isChooserVisible"
        ref="responsiblePersonsChooser"
        @chooseUser="handleChooseUser"
        @hiddenUserChooser="handleOnHiddenWidget"
    />
    <div class="flex flex-col h-[95%] gap-3">
        <ai-grid-edit-wrapper
            ref="gridEditRef"
            :meta="meta"
            :args="args"
            :add-custom-click="true"
            @grid-edit-wrapper-mounted="onGridEditWrapperMounted"
            @onAddClickEvent="handleAddClickEvent"
            @onHiddenWidget="handleOnHiddenWidget"
        >
        </ai-grid-edit-wrapper>
    </div>
</template>

<script setup>
import ResponisblePersonsChooser from '@/views/contracts/contract-card/responsible-persons-chooser.vue';
import { useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';
import { getContractCard } from '@/service/contract-service';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import { getValueFromChooser } from '@/service/nsi-service';

const isChooserVisible = ref(false);
const cardInfo = ref();
const gridEditRef = ref();
const gridInstance = ref(null);

const responsiblePersonsChooser = ref();
const contractResponsibleInstance = ref();
const route = useRoute();
const emit = defineEmits(['closePopup', 'readyWidgetTitle']);

const readyWidgetTitle = caption => {
    emit('readyWidgetTitle', caption);
};

const onGridEditWrapperMounted = async () => {
    cardInfo.value = await getContractCard(route.params.id);
    args.select.select_args.kod_dog = cardInfo.value.data?.kod_dog;
    contractResponsibleInstance.value = {
        refresh: gridEditRef.value.ref.setDataSource,
        userData: () => {},
        userSettings: () => {},
    };
    setActiveViewInfo(contractResponsibleInstance.value);
    await setViewData();
};

const handleChooseUser = async choosenValue => {
    isChooserVisible.value = false;
    const response = await getValueFromChooser(choosenValue?.official_id, choosenValue?.kodp);
    const objToInsert = {
        type: 'insert',
        data: {
            ...response?.data[0],
            kod_dog: cardInfo.value.data.kod_dog,
            official_id: choosenValue?.official_id,
            kod_dep: choosenValue?.kodp,
        },
        index: 0,
        key: Math.random().toString(),
    };
    await insertDataInInstance(gridInstance, objToInsert).then(() => {
        gridInstance.value.refresh();
    });
};

const insertDataInInstance = async (instance, insertionValue) => {
    if (insertionValue) {
        const changes = instance.value.option('editing.changes') || [];
        instance.value.option('editing.changes', [...changes, insertionValue]);
    }
};

const handleOnHiddenWidget = async () => {
    isChooserVisible.value = false;
};

onMounted(async () => {
    cardInfo.value = await getContractCard(route.params.id);
    args.select.select_args.kod_dog = cardInfo.value.data?.kod_dog;
    gridInstance.value = gridEditRef.value.ref.gridInstance;
    readyWidgetTitle(cardInfo.value.data?.ndog);
});

const makeChooserPopupvisible = () => {
    isChooserVisible.value = true;
};

const handleAddClickEvent = async () => {
    await makeChooserPopupvisible();
};

const args = {
    select: {
        meta_args: {
            select: 'dog.f_kr_dogobj_emp_select',
        },
        select_args: {
            kod_dog: null,
        },
    },
    save: {
        meta_args: {
            insert: 'dog.f_kr_dogobj_emp_insert',
            delete: 'dog.f_kr_dogobj_emp_delete',
        },
    },
};

const meta = {
    keyExpr: 'kod_obj_emp',
    wordWrapEnabled: true,
    scrollingMode: 'virtual',
    focusedRowEnabled: true,
    allowSelectAll: true,
    viewId: 'kr-dogobj-emp-view',
    api: {
        select: 'dog./dog/kr-dogobj-emp-select/get',
        save: 'dog./dog/kr-dogobj-emp-save/set',
    },
    columns: [
        {
            name: 'podr',
            caption: 'Подразделение',
            dataField: 'name',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 1,
            visible: true,
        },
        {
            name: 'fio',
            caption: 'ФИО',
            dataField: 'fio',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 2,
            visible: true,
        },
        {
            name: 'tel',
            caption: 'Телефон',
            dataField: 'tel',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 3,
            visible: true,
        },
        {
            name: 'e_address',
            caption: 'e_mail',
            dataField: 'e_mail',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 4,
            visible: true,
        },
        {
            name: 'name_dolzh',
            caption: 'Должность',
            dataField: 'name_dolzh',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 5,
            visible: true,
        },
        {
            name: 'dolzh_fun',
            caption: 'Должностная функция',
            dataField: 'name_fun',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 6,
            visible: true,
        },
        {
            name: 'pr_dog_podp_statuc',
            caption: 'Право подписания договора',
            dataField: 'pr_dog_podp_status',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 7,
            visible: true,
        },
        {
            name: 'active_status',
            caption: 'Статус',
            dataField: 'abbr',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 8,
            visible: true,
        },
        {
            name: 'kod_obj_emp',
            caption: 'kod_obj_emp',
            dataField: 'kod_obj_emp',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 9,
            visible: false,
        },
        {
            name: 'kod_dogpodr',
            caption: 'kod_dogpodr',
            dataField: 'kod_dogpodr',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 10,
            visible: false,
        },
    ],
};
</script>
